import React from "react";
import { Badge } from "reactstrap";

const BillingStatusBadge = ({ status }) => {
  let color;
  let displayText;

  switch (status) {
    case "PENDING":
      color = "warning"; // Yellow/Orange
      displayText = "PENDING";
      break;
    case "PAID":
      color = "success"; // Green
      displayText = "PAID";
      break;
    case "PARTIALLY_PAID":
      color = "info"; // Blue
      displayText = "PARTIALLY PAID";
      break;
    case "CANCELLED":
      color = "danger"; // Red
      displayText = "CANCELLED";
      break;
    default:
      color = "secondary"; // Grey
      displayText = status || "UNKNOWN";
  }

  return (
    <Badge
      color={color}
      style={{ padding: "6px 8px", fontSize: "12px", fontWeight: "500" }}
    >
      {displayText}
    </Badge>
  );
};

export default BillingStatusBadge;
